import { api } from '@/lib/axios'
import type { MailExportPayload, MailExportResult } from '@symphenia/shared-types'

/**
 * AP-10 Nachtrag 5 — **ein Export als Anfrage, nicht als Aufruf.**
 *
 * Eine Seite sagt nur noch, *welcher* Export mit *welchen* Parametern gemeint ist.
 * Daraus entstehen beide Wege: der Download (`GET url`) und der Mailversand
 * (`POST url/mail` mit denselben Parametern in der Query). Weil die Parameter
 * dieselben sind, liest das Backend sie mit derselben DTO-Klasse — und erzeugt
 * dieselbe Datei.
 *
 * So bekommt jeder Export-Knopf den Mailversand, ohne dass eine Seite ihn eigens
 * baut; die Gegenstelle im Backend erzwingt `export-per-mail.spec.ts`.
 */
export interface ExportRequest {
  /** Download-Pfad, z. B. `/time-entries/daily-work-times-export`. */
  url: string
  params?: Record<string, unknown>
  /** Nur wenn der Mailpfad nicht `${url}/mail` heißt (Abgabe: `…/:id/pdf` → `…/:id/mail`). */
  mailUrl?: string
}

export const exportLaden = (r: ExportRequest) =>
  api.get<ArrayBuffer>(r.url, { params: r.params, responseType: 'arraybuffer' })

/**
 * Nachtrag 5, 3a — gesendet wird ein Formular: `mail` als JSON, dazu eigene
 * Dateien im Feld `files`. Den `Content-Type` samt Grenze setzt der Browser.
 */
export const exportMailen = (r: ExportRequest, mail: MailExportPayload, dateien: readonly File[] = []) => {
  const formular = new FormData()
  formular.append('mail', JSON.stringify(mail))
  for (const d of dateien) formular.append('files', d, d.name)
  return api.post<{ data: MailExportResult }>(r.mailUrl ?? `${r.url}/mail`, formular, { params: r.params })
}
